"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanManager__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "planId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "planTemplateId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "PlanCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "planId",
                type: "uint256",
            },
        ],
        name: "PlanRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "templateId",
                type: "uint256",
            },
        ],
        name: "PlanTemplateCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "templateId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        name: "PlanTemplateMetadataChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "templateId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "active",
                type: "bool",
            },
        ],
        name: "PlanTemplateStatusChanged",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "planId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "acceptPlan",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "templateId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "deploymentId",
                type: "bytes32",
            },
        ],
        name: "createPlan",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "period",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "dailyReqCap",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rateLimit",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        name: "createPlanTemplate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "planId",
                type: "uint256",
            },
        ],
        name: "getPlan",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "indexer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "templateId",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "deploymentId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bool",
                        name: "active",
                        type: "bool",
                    },
                ],
                internalType: "struct Plan",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "templateId",
                type: "uint256",
            },
        ],
        name: "getPlanTemplate",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "period",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "dailyReqCap",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "rateLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "metadata",
                        type: "bytes32",
                    },
                    {
                        internalType: "bool",
                        name: "active",
                        type: "bool",
                    },
                ],
                internalType: "struct PlanTemplate",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "limit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextPlanId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextTemplateId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "planId",
                type: "uint256",
            },
        ],
        name: "removePlan",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_limit",
                type: "uint256",
            },
        ],
        name: "setIndexerPlanLimit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "templateId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        name: "updatePlanTemplateMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "templateId",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "active",
                type: "bool",
            },
        ],
        name: "updatePlanTemplateStatus",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class PlanManager__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "PlanManager";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.PlanManager__factory = PlanManager__factory;
PlanManager__factory.bytecode = _bytecode;
PlanManager__factory.abi = _abi;
